import { defineComponent as _defineComponent } from 'vue'
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';
import CcActionsPopover from '@/views/Automation/CampaignCreatorV2/components/CcPopover/CcActionsPopover.ts.vue';
import CcPopover from '@/views/Automation/CampaignCreatorV2/components/CcPopover/CcPopover.ts.vue';
import { Icons } from '@/views/Automation/CampaignCreatorV2/helpers/icons';
import { Level, MessageIcon, NavigationAction, NavigationMenu } from '@/views/Automation/CampaignCreatorV2/types';
import { PopoverTriggers, Position } from '@sh/types';
import { computed } from 'vue';

interface Props extends NavigationMenu {
  message?: MessageIcon;
  parent?: string;
  id: string;
  name: string;
  icon?: Icons;
  level: Level;
  actions?: NavigationAction[][];
}

interface Emits {
  (e: 'dispatch', value: NavigationAction): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewLevelRow.ts',
  props: {
    message: null,
    parent: { default: '' },
    id: null,
    name: null,
    icon: null,
    level: null,
    actions: { default: () => [[]] }
  },
  emits: ["dispatch"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'dispatch', value: NavigationAction): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { message?: MessageIcon, parent: string, id: string, name: string, icon?: Icons, level: Level, actions: NavigationAction[][] };





const hasActions = computed(() => props.actions.some((group) => group.length > 0));
const errorMessages = computed(() => props.message?.content.map((m) => m?.message));
const capitalizedLevel = computed(() => props.level.charAt(0).toUpperCase() + props.level.slice(1));

function dispatchEvent(action: any) {
  emits('dispatch', action as NavigationAction);
}

return { __sfc: true,props, emits, hasActions, errorMessages, capitalizedLevel, dispatchEvent, CcIcon, CcActionsPopover, CcPopover, PopoverTriggers, Position }
}

})